import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';
import { useContext } from 'react';
import SessionContext from '../contexts/SessionContext';
import API_URL from '../constants/environment';

interface CancelQuoteRequestInput {
    orderId: string;
    quoteRequestId: string;
}

const cancelQuoteRequest = async (data: CancelQuoteRequestInput, sessionId: string | null) => {
    return axios.put(`${API_URL}/order/request-quotes/cancel`, data, {
        headers: {
            Authorization: sessionId
        }
    });
};

export const useCancelQuoteRequest = () => {
    const sessionContext = useContext(SessionContext);
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (data: CancelQuoteRequestInput) => cancelQuoteRequest(data, sessionContext?.sessionId ?? null),
        onSuccess: (_data, variables) => {
            queryClient.invalidateQueries({ queryKey: ['/order/detail', variables.orderId] });
            queryClient.invalidateQueries({ queryKey: ['/order/drawer', variables.orderId] });
        },
        onError: (error) => {
            console.error('Failed to cancel quote request:', error);
        }
    });
};

